import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-suggestion-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './suggestion-badge.component.html',
  styleUrls: ['./suggestion-badge.component.scss']
})
export class SuggestionBadgeComponent {
  @Input() text: string = '';
  @Output() badgeClick = new EventEmitter<string>();

  onClick(): void {
    this.badgeClick.emit(this.text);
  }
}
